module.exports = "/React/dist/6d9fc39cd08b7c013451821037653f1a.png";